import React from "react";
import { Link } from "@quintype/components";
import { object, array, string } from "prop-types";

import NewsHeadline from "../../atoms/NewsHeadline";
import LiveText from "../../atoms/LiveText";
import KeyHighlights from "../KeyHighlights";

import "./liveBlogStoryCard.m.css";

const LiveBlogStoryCard = ({ story, keyHighlights, publisherLang }) => {
  return (
    <div styleName="live-blog-story-card" className="live-blog-story-card">
      <Link aria-label={story.headline} href={story.url}>
        <LiveText story={story} lang={publisherLang} />
        <NewsHeadline text={story} />
        {keyHighlights && (
          <div className="key-highlights-wrapper">
            <KeyHighlights keyHighlights={keyHighlights} />
            <div className="key-highlights-after"></div>
          </div>
        )}
      </Link>
    </div>
  );
};

LiveBlogStoryCard.propTypes = {
  story: object.isRequired,
  keyHighlights: array,
  publisherLang: string,
};

export default LiveBlogStoryCard;
